
(function() {
  var UNLOCK_ICON = '<svg class="fp-ship-bar__unlock" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="12" fill="#1F8A4C"/><rect x="7.3" y="11" width="9.4" height="7.2" rx="1.5" fill="#ffffff"/><path d="M9.2 11 V8.4 a2.8 2.8 0 0 1 5.4 -1.15" fill="none" stroke="#ffffff" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="14.3" r="1.05" fill="#1F8A4C"/></svg>';
const FREE_SHIP_BY_CURRENCY = {
    USD: 7500, EUR: 6500, GBP: 5500, CAD: 9900, AUD: 9900,
    NZD: 12900, CHF: 6000, JPY: 1200000, MXN: 134900,
    DKK: 49900, SEK: 74900, NOK: 69900, PLN: 28900, HUF: 2400000,
    RON: 34900, CZK: 160000, BGN: 12800
  };
  const KLARNA_INSTALLMENTS = 4;

  function getCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }
  function getThreshold() {
    return FREE_SHIP_BY_CURRENCY[getCurrency()] || 7500;
  }
  function symbol() {
    const cur = getCurrency();
    const m = { USD:'$', EUR:'€', GBP:'£', CAD:'CA$', AUD:'A$', NZD:'NZ$', CHF:'CHF ', JPY:'¥', MXN:'MX$', DKK:'kr', SEK:'kr', NOK:'kr', PLN:'zł', HUF:'Ft', RON:'lei', CZK:'Kč', BGN:'лв' };
    return m[cur] || '$';
  }
  function formatMoney(cents) {
    const cur = getCurrency();
    const noDec = ['JPY','HUF','KRW'].includes(cur);
    const v = noDec ? String(Math.round(cents/100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : (cents/100).toFixed(2);
    const sym = symbol();
    if (cur === 'EUR' || cur === 'CHF' || ['DKK','SEK','NOK','PLN','HUF','RON','CZK','BGN'].includes(cur)) {
      return v + ' ' + sym.trim();
    }
    return sym + v;
  }

  async function getCart() { try { return await fetch('/cart.js').then(r => r.json()); } catch(e) { return null; } }

  // ===========================================================================
  //  CATEGORY ENGINE v2 — tag-driven (mirrors fp-pdp.js)
  //  Tags are the most reliable signal. Audited against full FP catalog.
  // ===========================================================================
  function categoryOf(prod) {
    let tagsRaw = prod && prod.tags;
    let tags = [];
    if (Array.isArray(tagsRaw)) tags = tagsRaw;
    else if (typeof tagsRaw === 'string') tags = tagsRaw.split(/\s*,\s*/);
    const T = tags.map(t => String(t || '').toLowerCase().trim());
    const has = t => T.indexOf(t) !== -1;
    const typeL = String((prod && prod.product_type) || '').toLowerCase().trim();
    const titleL = String((prod && prod.title) || '').toLowerCase();

    if (has('gift box')) return 'gift-set';
    if (has('grinders') || has('grinder')) return 'grinder';
    if (has('cleaning kit') || /care kit|cleaning|barista care/.test(titleL)) return 'care';
    if (has('scales') || /scale\b/.test(titleL)) return 'scale';
    if (has('milk frother') || /frother|whisk\b/.test(titleL)) return 'frother';
    if (has('storage') || /canister|cellar|bean (display|storage)/.test(titleL)) return 'storage';
    if (has('spoons') || /scoop|spoon|tamper/.test(titleL)) return 'spoon';
    if (has('french press') || /french press|cafetière|cafetiere|press mug/.test(titleL)) return 'french-press';
    if (has('moka') || /moka|stovetop|bialetti/.test(titleL)) return 'moka';
    if (/cold (brew|drip)|cold-?drip|cold-?brew|drip tower/.test(titleL)) return 'cold-brew';
    if (has('over') || /pour[- ]over|chemex|v60/.test(titleL)) return 'pour-over';
    if (/aeropress/.test(titleL)) return 'aeropress';
    if (has('manual') && has('espresso')) return 'manual-espresso';
    if (has('espresso') && has('maker')) return 'espresso-machine';
    if (has('kettles') || has('kettle') || /kettle|bouilloire|teapot/.test(titleL)) {
      if (has('tea') || /tea/.test(titleL)) return 'tea';
      return 'kettle';
    }
    if (has('espresso glass') || /espresso (cup|glass)|demitasse|cortado|tasting glass|espresso cup/.test(titleL)) return 'espresso-cup';
    if (has('coffee glass') || /tasting mug|fluted/.test(titleL)) return 'coffee-cup';
    if (has('mug') || /mug|tumbler|flask/.test(titleL)) return 'mug';
    if (has('drinkware')) return 'mug';

    if (/grinder|burr|mill/.test(typeL)) return 'grinder';
    if (/kettle/.test(typeL)) return /tea/.test(typeL) ? 'tea' : 'kettle';
    if (/frother|whisk/.test(typeL)) return 'frother';
    if (/scale/.test(typeL)) return 'scale';
    if (/storage|canister/.test(typeL)) return 'storage';
    if (/spoon|scoop/.test(typeL)) return 'spoon';
    if (/cleaning|care/.test(typeL)) return 'care';
    if (/french press/.test(typeL)) return 'french-press';
    if (/cafetière|cafetiere|pour|over/.test(typeL)) return 'pour-over';
    if (/moka/.test(typeL)) return 'moka';
    if (/cold/.test(typeL)) return 'cold-brew';
    if (/espresso/.test(typeL)) return 'espresso-machine';
    if (/mug|cup|drinkware|glass|tumbler/.test(typeL)) return 'mug';
    if (/gift|set|kit/.test(typeL)) return 'gift-set';
    return 'other';
  }

  const COMPLEMENTS = {
    'french-press':     ['grinder','kettle','scale','mug','care','spoon','storage','coffee-cup'],
    'pour-over':        ['grinder','kettle','scale','mug','care','spoon','storage','coffee-cup'],
    'aeropress':        ['grinder','kettle','mug','care','scale','spoon'],
    'moka':             ['grinder','frother','espresso-cup','mug','care'],
    'espresso-machine': ['grinder','frother','espresso-cup','scale','care','spoon'],
    'manual-espresso':  ['grinder','scale','espresso-cup','care'],
    'cold-brew':        ['grinder','scale','storage','mug','spoon'],
    'grinder':          ['french-press','pour-over','espresso-machine','moka','kettle','scale','storage','spoon'],
    'kettle':           ['french-press','pour-over','aeropress','grinder','scale','mug','coffee-cup'],
    'tea':              ['mug','coffee-cup','spoon','storage'],
    'scale':            ['grinder','kettle','french-press','pour-over','espresso-machine','spoon','storage'],
    'frother':          ['moka','espresso-machine','espresso-cup','mug','grinder'],
    'mug':              ['french-press','pour-over','grinder','kettle','spoon','storage'],
    'coffee-cup':       ['french-press','pour-over','grinder','kettle','spoon'],
    'espresso-cup':     ['espresso-machine','manual-espresso','moka','frother','grinder'],
    'storage':          ['grinder','scale','spoon','french-press','pour-over'],
    'spoon':            ['french-press','grinder','storage','scale','pour-over','kettle'],
    'care':             ['french-press','espresso-machine','grinder','pour-over','moka'],
    'gift-set':         ['grinder','scale','spoon','storage','care'],
    'other':            ['grinder','kettle','french-press','mug']
  };

  // Cached catalog (single fetch shared across drawer opens)
  let _catalogPromise = null;
  function fetchCatalog() {
    if (_catalogPromise) return _catalogPromise;
    _catalogPromise = fetch('/products.json?limit=250')
      .then(r => r.json())
      .then(d => (d && d.products) || [])
      .catch(() => []);
    return _catalogPromise;
  }

  async function getUpsellProducts(currentIds, currentProductId, limit, currentProductType, currentTitle) {
    limit = limit || 6;
    const catalog = await fetchCatalog();
    if (!catalog.length) return [];

    // Resolve current product (use first cart item) for accurate categoryOf
    let currentProd = null;
    if (currentProductId) {
      currentProd = catalog.find(p => p.id == currentProductId) || null;
    }
    if (!currentProd) {
      currentProd = { title: currentTitle || '', product_type: currentProductType || '', tags: [] };
    }
    const currentCat = categoryOf(currentProd);

    // Categories of OTHER items in the cart (avoid recommending what's already there's category)
    const cartCats = new Set([currentCat]);
    for (const id of currentIds) {
      const cp = catalog.find(p => p.id == id);
      if (cp) cartCats.add(categoryOf(cp));
    }

    const prefs = COMPLEMENTS[currentCat] || COMPLEMENTS['other'];

    const candidates = [];
    for (const p of catalog) {
      if (!p || !p.variants || !p.variants.length) continue;
      if (p.published_at === null) continue;
      if (currentIds.includes(p.id)) continue;
      const cat = categoryOf(p);
      if (cat === currentCat) continue;          // never competing with main item
      const idx = prefs.indexOf(cat);
      if (idx === -1) continue;                   // not a real complement
      // Slight penalty if its category is already in the cart (already bought)
      const inCartPenalty = cartCats.has(cat) ? 100 : 0;
      candidates.push({ p, cat, score: idx + inCartPenalty });
    }

    candidates.sort((a, b) => {
      if (a.score !== b.score) return a.score - b.score;
      return new Date(b.p.updated_at || 0) - new Date(a.p.updated_at || 0);
    });

    // Diversify: max 2 per category in cart drawer (8 slots so 2x4 tops)
    const perCat = {};
    const out = [];
    for (const c of candidates) {
      if (out.length >= limit) break;
      perCat[c.cat] = (perCat[c.cat] || 0) + 1;
      if (perCat[c.cat] > 2) continue;
      out.push(c.p);
    }
    return out;
  }

  function buildShipDone() {
    return '<div class="fp-ship-done" data-fp-ship-bar><svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1F7A4D"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Free shipping unlocked</span></div>';
  }
  // 30/09/26 : bas du tiroir façon Atlas : livraison + TOTAL avec le montant, juste au-dessus du bouton
  // montant au format du pays du visiteur (149,00 € en FR, $149.00 aux US), comme les prix des lignes
  function fpTotalMoney(cents) {
    try { const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; const loc = document.documentElement.lang || (window.Shopify && Shopify.locale) || 'en-US';
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); } catch (e) { return formatMoney(cents); }
  }
  function buildTotals(total) {
    const free = total >= getThreshold();
    return '<div class="fp-totals" data-fp-totals>'
      + '<div class="fp-totals__row"><span>Shipping</span>' + (free ? '<span class="fp-totals__free">&#10003; Free</span>' : '<span class="fp-totals__muted">Calculated at checkout</span>') + '</div>'
      + '<div class="fp-totals__row fp-totals__row--total"><span>Total</span><strong class="notranslate" translate="no">' + fpTotalMoney(total) + '</strong></div>'
      + '</div>';
  }

  function buildShipBar(total) {
    const threshold = getThreshold();
    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, (total / threshold) * 100);
    const reached = remaining === 0 && total > 0;
    const text = reached ? '<strong>Free shipping unlocked</strong>' + UNLOCK_ICON
      : 'Add <strong>' + formatMoney(remaining) + '</strong> for <strong>free shipping</strong>';
    return '<div class="fp-ship-bar' + (reached ? ' fp-ship-bar--done' : '') + '" data-fp-ship-bar><div class="fp-ship-bar__text">' + text + '</div><div class="fp-ship-bar__track"><div class="fp-ship-bar__fill" style="width:' + progress + '%"></div></div></div>';
  }

  function getCountdownText() {
    const now = new Date();
    const next = new Date(now);
    const nh = (Math.floor(now.getHours() / 6) + 1) * 6;
    if (nh >= 24) { next.setDate(next.getDate() + 1); next.setHours(0,0,0,0); } else { next.setHours(nh,0,0,0); }
    const diff = Math.max(0, next - now);
    return Math.floor(diff/3600000) + 'h ' + Math.floor((diff%3600000)/60000) + 'min ' + Math.floor((diff%60000)/1000) + 's';
  }

  function buildCountdown() {
    // FP V3 — Lynore translation patch: wrap the dynamic time digits in
    // class="notranslate" translate="no" so Google Translate / Shopify Markets
    // doesn't re-translate the live ticker (which breaks formatting).
    return '<div class="fp-countdown" data-fp-countdown><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><span>Delivered in <strong>6 to 10 business days</strong> · tracking included</span></div>';
  }

  // 30/09/26 (Mathéo) : date de livraison estimée en bas du tiroir, juste au-dessus du total, comme Atlas.
  // Même calcul que la fiche produit et qu'Atlas : commande + 6 à 10 jours (calendaires), demande Mathéo 30/09.
  function fpEtaAddBusinessDays(n) { const x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); const wd = x.getDay(); if (wd !== 0 && wd !== 6) n--; } return x; }
  function buildEta() {
    try {
      const lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en-US';
      const fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', month: 'short', day: 'numeric' });
      const add = (n) => { const x = new Date(); x.setDate(x.getDate() + n); while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1); return x; }; // 05/10/26 jamais un week-end (fp-express-checkout-2026-10-05)
      const r = fmt.format(add(6)) + ' – ' + fmt.format(add(10));
      return '<div class="fp-eta-line" data-fp-eta-line><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg><span>Order today, estimated delivery&nbsp;<strong class="notranslate" translate="no">' + r + '</strong></span></div>';
    } catch (e) { return ''; }
  }

  function buildTrust() {
    return '<div class="fp-cart-trust" data-fp-cart-trust>'
      + '<div class="fp-cart-trust__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg><span>1-year guarantee</span></div>'
      + '<div class="fp-cart-trust__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg><span>Secure checkout</span></div>'
      + '<div class="fp-cart-trust__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/></svg><span>35+ countries</span></div>'
      + '</div>';
  }

  function buildKlarna(total) {
    const inst = total / KLARNA_INSTALLMENTS;
    return '<div class="fp-klarna" data-fp-klarna><span class="fp-klarna__brand">Klarna<span class="fp-klarna__dot">.</span></span><span class="fp-klarna__text">' + KLARNA_INSTALLMENTS + ' interest-free payments of <strong>' + formatMoney(inst) + '</strong>.</span></div>';
  }

  function buildUpsellCard(product) {
    if (!product) return '';
    const variant = product.variants[0];
    const imgRaw = (product.images && product.images[0]) || product.featured_image || '';
    const img = typeof imgRaw === 'object' && imgRaw !== null ? (imgRaw.src || imgRaw.url || '') : imgRaw;
    // Robust price parsing (handles "29.00" string and 2900 integer)
    function toCents(v) {
      if (v == null || v === '') return 0;
      const s = String(v);
      return s.indexOf('.') >= 0 ? Math.round(parseFloat(s) * 100) : (parseInt(s, 10) || 0);
    }
    const cents = toCents(variant.price);
    const cmpCents = toCents(variant.compare_at_price);
    const onSale = cmpCents > cents && cents > 0;
    const pct = onSale ? Math.round((1 - cents / cmpCents) * 100) : 0;

    const url = (window.Shopify.routes.root + 'products/') + product.handle;
    const priceHTML = onSale
      ? '<div class="fp-upsell__price fp-upsell__price--sale"><s>' + formatMoney(cmpCents) + '</s> <strong>' + formatMoney(cents) + '</strong></div>'
      : '<div class="fp-upsell__price">' + formatMoney(cents) + '</div>';
    const badgeHTML = onSale
      ? '<span class="fp-upsell__badge">-' + pct + '%</span>'
      : '';

    return '<div class="fp-upsell__slide">'
      + '<a href="' + url + '" class="fp-upsell__media-link" aria-label="' + product.title + '">'
      +   '<div class="fp-upsell__media">'
      +     badgeHTML
      +     (img ? '<img src="' + img + '" alt="' + product.title + '" loading="lazy" />' : '')
      +   '</div>'
      + '</a>'
      + '<a href="' + url + '" class="fp-upsell__name">' + product.title + '</a>'
      + priceHTML
      + '<button type="button" class="fp-upsell__add" data-variant-id="' + variant.id + '">+ Add</button>'
      + '</div>';
  }
  function buildUpsell(products) {
    if (!products || !products.length) return '';
    const slides = products.map(buildUpsellCard).join('');
    return '<div class="fp-upsell" data-fp-upsell><div class="fp-upsell__head"><div class="fp-upsell__title">You may also like</div><div class="fp-upsell__nav"><button type="button" class="fp-upsell__arrow" data-fp-upsell-prev aria-label="Previous">‹</button><button type="button" class="fp-upsell__arrow" data-fp-upsell-next aria-label="Next">›</button></div></div><div class="fp-upsell__track" data-fp-upsell-track>' + slides + '</div></div>';
  }function findDialog() { return document.querySelector('cart-drawer-component dialog'); }

  let injectingNow = false;
  async function injectIntoDrawer() {
    if (injectingNow) return;
    injectingNow = true;
    setTimeout(() => { injectingNow = false; }, 120);

    const dlg = findDialog();
    if (!dlg) return;
    const cart = await getCart();
    if (!cart) return;
    const total = cart.total_price;
    const isEmpty = cart.item_count === 0;

    // Renames
    const heading = dlg.querySelector('.cart-drawer__heading');
    if (heading) {
      heading.childNodes.forEach(n => {
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim() === 'Cart') n.nodeValue = ' Your bag ';
      });
    }
    const checkoutBtn = dlg.querySelector('#checkout, button[name="checkout"], .cart__checkout-button');
    if (checkoutBtn) {
      const span = checkoutBtn.querySelector('.button-text, span');
      if (span) span.textContent = 'Secure checkout';
    }

    // Cleanup old fp injections
    dlg.querySelectorAll('[data-fp-ship-bar],[data-fp-cart-trust],[data-fp-klarna],[data-fp-upsell],[data-fp-countdown],[data-fp-eta-line],[data-fp-totals]').forEach(el => el.remove());

    // Inject ship bar + countdown only when cart has items
    const headerWrap = dlg.querySelector('.cart-drawer__header');
    if (headerWrap && !isEmpty) {
      // 30/09/26 (Mathéo) : plus de « Delivered in 6 to 10 business days » ni de « Free shipping unlocked » en haut ; la barre reste tant que le seuil n'est pas atteint
      headerWrap.insertAdjacentHTML('afterend', buildEta() + (total >= getThreshold() ? buildShipDone() : buildShipBar(total)));
    }

    if (!isEmpty) {
      // 30/09/26 (Mathéo) : « You may also like » retiré du tiroir ; bouton « Secure checkout » sans le montant ;
      // date de livraison estimée juste au-dessus du total.
      if (checkoutBtn) {
        const labelEl = checkoutBtn.querySelector('.button-text') || checkoutBtn.querySelector('span:not([class*="icon"])');
        if (labelEl) labelEl.textContent = 'Secure checkout';
      }
      const ctas = dlg.querySelector('.cart__ctas');
      if (ctas) ctas.insertAdjacentHTML('beforebegin', buildTotals(total));
      // FP V3 — Klarna and trust badges removed from drawer per user request
    }

    // Final dedup
    ['[data-fp-ship-bar]','[data-fp-cart-trust]','[data-fp-klarna]','[data-fp-upsell]','[data-fp-countdown]','[data-fp-eta-line]','[data-fp-totals]'].forEach(sel => {
      const els = dlg.querySelectorAll(sel);
      els.forEach((el, i) => { if (i > 0) el.remove(); });
    });

    // FP V3 — Anti-FOUC: mark dialog as ready so CSS can swap pre-styled placeholders
    // for the real (now-customized) UI. Also flag the checkout button so its baseline
    // CSS pseudo-element ("Secure checkout") releases and the JS-set text shows.
    dlg.setAttribute('data-fp-ready', '1');
    if (checkoutBtn) checkoutBtn.setAttribute('data-fp-checkout-final', '1');
  }

  // Live countdown updater
  setInterval(() => {
    const el = document.querySelector('[data-fp-countdown-time]');
    if (el) el.textContent = getCountdownText();
  }, 1000);

  // Upsell click
  // Carousel arrow nav
  document.addEventListener('click', e => {
    const prev = e.target.closest('[data-fp-upsell-prev]');
    const next = e.target.closest('[data-fp-upsell-next]');
    if (prev || next) {
      const track = (prev || next).closest('.fp-upsell').querySelector('[data-fp-upsell-track]');
      if (track) {
        const slide = track.querySelector('.fp-upsell__slide');
        const step = slide ? slide.getBoundingClientRect().width + 12 : 162;
        track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
      }
    }
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('.fp-upsell__add');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id, quantity: 1 }) });
      btn.textContent = 'Added';
      setTimeout(() => window.location.reload(), 600);
    } catch(err) { btn.textContent = 'Error'; btn.disabled = false; }
  });

  let lastOpen = false;
  setInterval(() => {
    const dlg = findDialog();
    const open = dlg && dlg.open;
    if (dlg && !dlg.__fpObs) { dlg.__fpObs = true; var _fpReinjectT; new MutationObserver(function(){ if (dlg.open && !dlg.querySelector('[data-fp-ship-bar]')) { clearTimeout(_fpReinjectT); _fpReinjectT = setTimeout(injectIntoDrawer, 60); } }).observe(dlg, { childList: true, subtree: true }); }
    if (open && !lastOpen) {
      setTimeout(injectIntoDrawer, 50);
      setTimeout(injectIntoDrawer, 300);
    }
    if (open && !dlg.querySelector('[data-fp-ship-bar]')) injectIntoDrawer();
    lastOpen = open;
  }, 500);

  ['cart:updated','cart:refresh','cart:change','cart:add','cart:item:update'].forEach(evt => {
    document.addEventListener(evt, () => setTimeout(injectIntoDrawer, 100));
  });

  // === FP V3 — Standalone /cart page enhancements ===
  async function enhanceCartPage() {
    const page = document.querySelector('.cart-page, .template-cart');
    if (!page) return;
    const cart = await getCart();
    if (!cart) return;
    const total = cart.total_price;
    const isEmpty = cart.item_count === 0;

    // Rename heading "Cart" -> "Your bag"
    page.querySelectorAll('h1').forEach(h => {
      const tn = [...h.childNodes].find(n => n.nodeType === 3 && n.nodeValue && n.nodeValue.trim() === 'Cart');
      if (tn) tn.nodeValue = ' Your bag ';
    });

    // Rename checkout button -> "Secure checkout"
    const ckBtn = page.querySelector('.cart__checkout-button, [name="checkout"]');
    if (ckBtn) {
      const span = ckBtn.querySelector('.button-text, span');
      if (span) span.textContent = 'Secure checkout';
    }

    // Cleanup prior fp injections
    page.querySelectorAll('[data-fp-page-shipbar],[data-fp-page-klarna],[data-fp-page-trust]').forEach(e => e.remove());
    if (isEmpty) return;

    // Ship bar — at top of cart-items area
    const itemsTop = page.querySelector('.cart-items, .cart-items__wrapper, .cart-items__table');
    if (itemsTop) {
      const threshold = getThreshold();
      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, (total / threshold) * 100);
      const reached = remaining === 0 && total > 0;
      const txt = reached ? '<strong>Free shipping unlocked</strong>' + UNLOCK_ICON
        : 'Add <strong>' + formatMoney(remaining) + '</strong> for <strong>free shipping</strong>';
      itemsTop.insertAdjacentHTML('beforebegin',
        '<div class="fp-cart-page-shipbar' + (reached ? ' fp-ship-bar--done' : '') + '" data-fp-page-shipbar>'
        + '<div class="fp-ship-bar__text">' + txt + '</div>'
        + '<div class="fp-ship-bar__track"><div class="fp-ship-bar__fill" style="width:' + progress + '%"></div></div>'
        + '</div>'
      );
    }

    // Klarna BELOW checkout button (no more trust badges per user request)
    if (ckBtn && ckBtn.parentNode) {
      const klarna = '<div class="fp-klarna" data-fp-page-klarna><span class="fp-klarna__brand">Klarna<span class="fp-klarna__dot">.</span></span><span class="fp-klarna__text">' + KLARNA_INSTALLMENTS + ' interest-free payments of <strong>' + formatMoney(total / KLARNA_INSTALLMENTS) + '</strong>.</span></div>';
      ckBtn.insertAdjacentHTML('afterend', klarna);
    }
  }

  // Run on /cart pages
  if (document.querySelector('.cart-page, .template-cart')) {
    setTimeout(enhanceCartPage, 100);
    document.addEventListener('cart:updated', () => setTimeout(enhanceCartPage, 100));
    document.addEventListener('cart:refresh', () => setTimeout(enhanceCartPage, 100));
  }

})();
